<template>
    <!--
            作者：kmdshop
            时间：2019-10-25
            描述：门店列表
        -->

        <div>

            <div style="float: left;width:25%;">
        <Supply_s  @handleCurrentChange="handleCurrentChangeS" @reast="reasts"></Supply_s>
    </div>


            <div style="float: left;width:72%;margin-left: 1%;">
    <div class="user">
  
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

  
          <el-form-item label="是否审核">
            <el-select v-model="formInline.audit_status" placeholder="请选择">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="未审核" :value="0"></el-option>
              <el-option label="通过" :value="1"></el-option>
              <el-option label="未通过" :value="2"></el-option>
              
            </el-select>
          </el-form-item>
  
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--添加门店-->
     
      <div class="common-level-rail">
        <!-- <el-button size="small" type="primary" 
        icon="el-icon-plus" @click="addShopClick" v-auth="'/store/store/addShop'">添加商城(会自动创建门店)</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/store/store/add'">添加门店</el-button>
      
      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="store_id" label="门店ID" width="60"></el-table-column>
            <el-table-column prop="user_supply.name" label="商家" width="60"></el-table-column>
            <el-table-column prop="supply.name" label="绑定供应商" width="60"></el-table-column>
            <el-table-column label="Logo" width="60">
              <template slot-scope="scope">
                <img v-if="scope.row.logo" v-img-url="scope.row.logo" width="30px" height="30px" />
              </template>
            </el-table-column>
            <el-table-column prop="store_name" label="门店名称"></el-table-column>
            <el-table-column prop="shop_hours" label="营业时间">
              <template slot-scope="scope">
                {{ scope.row.shop_hours_start }}~{{ scope.row.shop_hours_end }}
              </template>
  
            </el-table-column>
            <!-- <el-table-column prop="shopManager.user.nickName" label="店长"></el-table-column> -->
            <el-table-column prop="linkman" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系电话" width="100"></el-table-column>
            <el-table-column prop="detail_address" label="门店地址" width="150"></el-table-column>
            <el-table-column prop="is_check" label="自提核销">
              <template slot-scope="scope">
                <span :class="{ green: scope.row.is_check.value == 1, gray: scope.row.is_check.value == 0 }">{{ scope.row.is_check.text }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="门店状态">
              <template slot-scope="scope">
                <span :class="{ green: scope.row.status.value == 1, gray: scope.row.status.value == 0 }">{{ scope.row.status.text }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="audit_status" label="是否通过">
              <template slot-scope="scope">
                <span v-if="scope.row.audit_status == 0">未审核</span>
                <span v-if="scope.row.audit_status == 1">审核通过</span>
                <span v-if="scope.row.audit_status == 2">未通过</span>
              </template>
            </el-table-column>
  
            <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
         
                <el-button @click="passClick(scope.row)"
                v-auth="'/store/store/audit_success'"
                type="text" size="small" v-if="scope.row.audit_status == 0">审核通过</el-button>
                <el-button @click="nopassClick(scope.row)"
                v-auth="'/store/store/audit_fail'"
                type="text" size="small" v-if="scope.row.audit_status == 0">审核不通过</el-button>
                
                
                <!-- <el-button @click="cardClick(scope.row)" type="text" size="small" v-auth="'/store/store/card'">补充信息</el-button> -->
                <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/store/store/edit'">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/store/store/delete'">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
  
      <!-- <Oss :open_add="open_oss" :store_id="store_id" :form="obj"  v-if="open_oss"   @close="closeOss"></Oss> -->
    </div>
</div>

        </div>

       
  </template>
  
  <script>
  import StoreApi from '@/api/store.js';

import Supply_s from '@/components/select/supplys';
  export default {
    components: {
        Supply_s
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*所属供应商数据*/
        supplyList: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
         supply_id:0,
         audit_status:-1,
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        open_oss:false,
        store_id:0,
        obj:{},
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
      if (this.$route.query.supply_id != null) {
          this.formInline.supply_id = this.$route.query.supply_id;
        }
    },
    methods: {

    handleCurrentChangeS(val){
        this.formInline.supply_id = val.id
        this.getTableList();
      },
      reasts(){
  
        this.formInline.supply_id = 0

        this.getTableList();
      },

      cardClick(item){
        this.store_id = item.store_id;
        this.obj = item;
        this.open_oss = true;
      },
      closeOss(e){
        this.open_oss=false;
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      onSubmit(){
          this.getTableList();
      },
  
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        StoreApi.shoplist(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            self.supplyList = data.data.supply_list
          })
          .catch(error => {});
      },
      addShopClick(){
        this.$router.push('/store/store/addshop');
      },
      /*打开添加*/
      addClick() {
        this.$router.push('/store/store/add');
      },
  
      /*打开编辑*/
      editClick(row) {
        let self = this;
        let params = row.store_id;
        this.$router.push({
          path: '/store/store/edit',
          // name: 'mallList',
          query: {
            store_id: params
          }
        });
      },
  
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            StoreApi.deleteShop(
              {
                store_id: row.store_id
              },
              true
            )
              .then(data => {
                self.$message({
                  message: '恭喜你，门店删除成功',
                  type: 'success'
                });
                self.getTableList();
              })
              .catch(error => {});
          })
          .catch(() => {});
      },
      passClick(item){//退款申请-通过审核
        var self = this;
        
        self
            .$confirm('是否通过?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              var Params = {
                store_id:item.store_id,
                audit_status:1,//0 未审核  1 审核通过  2 审核不通过
              }
              StoreApi.passCanel(Params, true)
                .then(data => {
                  console.log(data)
                  if(data.code == 1){
                    self.$message({
                        type: 'success',
                        message: '审核成功'
                    });
                      self.getTableList();
                      return false;
                  }
                })
                .catch(error => {
                  
                
                });
            })
            .catch(() => {
            });
        
      
  
      },
      async nopassClick(item){//退款申请-不通过审核
        var self = this;
        const reject_val = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');
  
        var Params = {
          store_id:item.store_id,
          audit_status:2,//0 未审核  1 审核通过  2 审核不通过
          reject_val:reject_val
        }
        StoreApi.passCanel(Params, true)
          .then(data => {
            if(data.code == 1){
              self.$message({
                  type: 'success',
                  message: '审核成功'
              });
                self.getTableList();
                return false;
            }
          })
          .catch(error => {});
      },
      async promptInput(message, validation) {
        try {
          const { value } = await this.$prompt(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputErrorMessage: validation,
          });
          return value.trim();
        } catch(e) {
          this.$message({
            type: 'info',
            message: '取消输入',
          });
        }
      },
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/supply/store/index.vue